export default __webpack_public_path__ + "static/media/TitilliumWeb-Light.2b8d1521.ttf";